
<template>
  <div>
    <dialog-edit-employee></dialog-edit-employee>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogEditEmployee from '../../components/employee/DialogEditEmployee.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'ShowEmployeePage',
  //mixins: [ validations ],
  components: {
    DialogEditEmployee
    //ComponentName: () => import(''),
  },
  data() {
    return {
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>